import React, { useState } from 'react';
import { Row, Col } from '@zendeskgarden/react-grid';
import { get, isString, map } from 'lodash';
import { Button } from 'theme/Button';
import { variables } from 'theme/variables';
import { SM } from '@zendeskgarden/react-typography';
import InspectionScopesOverlay from 'routes/Products/components/InspectionScopesOverlay/InspectionScopesOverlay';
import InPageOverlay from 'components/InPageOverlay/InPageOverlay';
import { openModal } from 'state/modals/actions';
import {
  PercentageDiv,
  InspectionScope,
  NoStartMessage,
} from './InspectionMetrics.styles';
import { productNominalDetailsShape } from '../../../../../propTypesObjects';

const { custom_blue: customBlue } = variables;

function InspectionMetrics({ productDetails }) {
  const [inPageOverlayViewOpen, setInPageOverlay] = useState(false);

  const lotSummary = productDetails?.lot_summary;
  const inspectionInfo = productDetails?.quality_information;
  const inspectionCriteriaScope = get(lotSummary, 'inspection_criteria_scope');
  const tallyJoints = get(inspectionCriteriaScope, 'tally_joints');
  const drift = get(lotSummary, 'drift');
  const driftStandardJoints = get(drift, 'drift_standard_required');
  const driftAltJoints = get(drift, 'drift_alt_required');
  const drift2ndAltJoints = get(drift, 'drift_2nd_alt_required');
  const driftStandardInspected = get(drift, 'drift_standard_performed');
  const driftAltInspected = get(drift, 'drift_alt_performed');
  let driftJoints = 0;
  if (driftStandardInspected > 0) {
    driftJoints = driftStandardJoints;
  } else if (driftAltInspected > 0) {
    driftJoints = driftAltJoints;
  } else {
    driftJoints = drift2ndAltJoints;
  }
  // Drift required joints can be populated with "-". If so, use tally required joint count
  if (isString(driftJoints)) {
    driftJoints = tallyJoints;
  }

  return (
    <InspectionScope noStart={productDetails?.inspection_status === 0}>
      <Row
        className={
          productDetails?.inspection_status === 0
            ? 'scopeList_default'
            : 'scopeList'
        }
      >
        {productDetails?.inspection_status === 0 ? (
          <NoStartMessage>
            As Inspections begin, inspection scopes will be updated here.
            <SM
              as="span"
              className="learnMoreLink_default"
              semibold
              blue
              link
              onClick={() => setInPageOverlay(true)}
            >
              learn more about our inspection process
            </SM>
          </NoStartMessage>
        ) : (
          <>
            {map(inspectionInfo?.inspections, (group, idx) => (
              <Row className="inspectionList" key={group}>
                <Col className="percentageBubble" lg={2} md={3}>
                  <PercentageDiv percentage={inspectionInfo.bubbles[idx] || 0}>
                    <div className="percentage_div">
                      {inspectionInfo.bubbles[idx] || 0}%
                    </div>
                  </PercentageDiv>
                </Col>
                <Col className="listItems" lg={10}>
                  {map(group, (item) => (
                    <Row className="inspectionScopeItems" key={item}>
                      <Col
                        lg={10}
                        style={{ padding: item?.checked ? '0' : '5px 0' }}
                      >
                        {item}
                      </Col>
                    </Row>
                  ))}
                </Col>
              </Row>
            ))}
          </>
        )}
      </Row>
      <Row className="scopeMoreInfo">
        <span>Want to see this PipeFacts Report?&nbsp;</span>
        <Button
          tabIndex={0}
          onClick={(e) => {
            e.preventDefault();
            openModal({
              type: 'quickInqueryModalForReal',
            });
          }}
          id="submitInquiry"
          style={{ color: customBlue, cursor: 'pointer' }}
        >
          {' '}
          Submit an Inquiry!
        </Button>
        <InPageOverlay
          showClose
          onClose={() => setInPageOverlay(false)}
          open={inPageOverlayViewOpen}
          innerStyle={{
            height: '100%',
            overflowY: 'scroll',
            maxHeight: '850px',
          }}
          disableScroll
        >
          <div style={{ padding: '30px' }}>
            <InspectionScopesOverlay />
          </div>
        </InPageOverlay>
      </Row>
    </InspectionScope>
  );
}

InspectionMetrics.propTypes = {
  productDetails: productNominalDetailsShape,
};

export default InspectionMetrics;
